import request from "@/utils/request";
import store from "@/store";

export function getDocSection(params) {
  return request({
    url: `/documents/section/`,
    method: `get`,
    params,
  });
}

export function getDocSectionId(id, params) {
  return request({
    url: `/documents/section/${id}/`,
    method: `get`,
    params,
  });
}

export function putDocSection(id, data) {
  data.image = typeof data.image === "object" ? data.image.path : data.image;
  return request({
    url: `/documents/section/${id}/`,
    method: `put`,
    data,
  });
}

export function postDocSection(data) {
  data.image = data.image.path;
  data.type_id =
    data.type_id === "regional"
      ? store.getters.types.regional
      : store.getters.types.federal;
  return request({
    url: `/documents/section/`,
    method: `post`,
    data,
  });
}

export function deleteDocSection(id) {
  return request({
    url: `/documents/section/${id}/`,
    method: `delete`,
  });
}
